import { render, staticRenderFns } from "./FCellRouterLink.vue?vue&type=template&id=5c890798&"
import script from "./FCellRouterLink.vue?vue&type=script&lang=ts&"
export * from "./FCellRouterLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports